import { getServerUrl } from './utils/stackUtils';

const config = {
  serverUrl: getServerUrl(),
  mapBoxAccessToken: import.meta.env.VITE_MAPBOX_ACCESS_TOKEN,
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  // Pathway that GCON's "Take into modeling" opens; the button is hidden when unset
  gconModelingUrl: import.meta.env.VITE_GCON_MODELING_URL,
};

export default config;
